export const ROUTE_NAME_ASSET_LIST: string = 'asset-list';
export const ROUTE_NAME_DEAL_LIST: string = 'deal-list';
export const ROUTE_NAME_CONTACT_LIST: string = 'contact-list';
export const ROUTE_NAME_ACTIVITY_LIST: string = 'activity-list';
export const ROUTE_NAME_REPORT_LIST: string = 'report-list';
